<!-- Like.vue -->
<template>
	<div
		class="ui-like-wrapper"
		v-if="detailInfo && detailInfo.collector && detailInfo.collector.length > 0"
	>
		<div class="ui-detail-common">
			<div class="header">
				<span>点赞</span> <span>{{ detailInfo.collector.length }}</span>
			</div>
		</div>

		<div class="like-body">
			<div
				v-for="(item, index) in detailInfo.collector"
				v-if="index < 10"
				v-bind:key="index"
			>
				<img :src="item.thumb" v-if="item.thumb" />

			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
	data() {
		return {}
	},

	mounted() {},

	created() {},

	computed: {
		...mapState({
			detailInfo: state => state.goodsdetail.detailInfo
		})
	}
}
</script>

<style lang="scss" scoped>
.ui-like-wrapper {
	background-color: #ffffff;
	.header {
		border-bottom: 1px solid #e8eaed;
		span:first-child {
			font-size: 0.8rem;
			color: rgba(78, 84, 93, 1);
			line-height: 1rem;
		}
		span:last-child {
			font-size: 0.65rem;
			color: rgba(124, 127, 136, 1);
			line-height: 0.9rem;
		}
	}
	.like-body {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		align-content: center;
		padding: 0.7rem 0.55rem;
		position: relative;
		overflow: auto;
		div {
			width: 2rem;
			height: 2rem;
			display: inline-block;
			position: relative;
			img {
				width: 2rem;
				height: 2rem;
				position: relative;
				border: 0.1rem solid #fff;
				border-radius: 50%;
				box-shadow: 0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.1);
			}
		}
	}
}
</style>
